import { render, staticRenderFns } from "./myBookingStats.vue?vue&type=template&id=4bac8378&scoped=true"
import script from "./myBookingStats.vue?vue&type=script&lang=js"
export * from "./myBookingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac8378",
  null
  
)

export default component.exports